import { OnInit } from '@angular/core';
var ProgressStepperComponent = /** @class */ (function () {
    function ProgressStepperComponent() {
        this.nodeList = [];
    }
    Object.defineProperty(ProgressStepperComponent.prototype, "setDocumentList", {
        set: function (doc) {
            this.buildDocumentList(doc);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProgressStepperComponent.prototype, "progressChanged", {
        set: function (progressValue) {
            var _this = this;
            if (progressValue) {
                this.progress.Nodes.forEach(function (node) {
                    if (node.Order < _this.progress.Nodes.find(function (x) { return x.Value == progressValue; }).Order) {
                        node.IsSelected = true;
                    }
                    else if (node.Order == _this.progress.Nodes.find(function (x) { return x.Value == progressValue; }).Order) {
                        node.IsSelected = true;
                    }
                    else if (node.Order > _this.progress.Nodes.find(function (x) { return x.Value == progressValue; }).Order) {
                        node.IsSelected = false;
                    }
                });
            }
        },
        enumerable: true,
        configurable: true
    });
    ProgressStepperComponent.prototype.ngOnInit = function () {
    };
    ProgressStepperComponent.prototype.buildDocumentList = function (dirtyList) {
        // dirtyList = "(Bank:Compare)|(Doc:Additional Info)|LO:Accept Offer|";
        var _this = this;
        this.progress = JSON.parse(dirtyList);
        this.nodeList = this.progress.Nodes.filter(function (x) { return !x.IsHidden; });
        // this.nodeList.forEach(element => {
        //   element.IsSelected = false;
        // });
        var i = 0;
        this.nodeList.forEach(function (node) {
            if (i > 0) {
                if (!_this.progress.Nodes[i - 1].IsSelected) {
                    node.DelayAmount = i;
                }
            }
            i++;
        });
        this.sortNodes();
    };
    ProgressStepperComponent.prototype.sortNodes = function () {
        this.nodeList = this.nodeList.sort(function (a, b) {
            if (a.Order > b.Order) {
                return 1;
            }
            else if (a.Order < b.Order) {
                return -1;
            }
            else {
                return 0;
            }
        });
    };
    return ProgressStepperComponent;
}());
export { ProgressStepperComponent };
var Document = /** @class */ (function () {
    function Document() {
    }
    return Document;
}());
export { Document };
var Progress = /** @class */ (function () {
    function Progress() {
    }
    return Progress;
}());
export { Progress };
var Node = /** @class */ (function () {
    function Node() {
    }
    return Node;
}());
export { Node };
